import { Flex } from "../../../../components/flex/Flex"
import InfoBox from "../../../../components/info/InfoBox"
import { InfoText } from "../../../../components/info/InfoText"
import { Spacer } from "../../../../components/spacer/Spacer"
import { theme } from "../../../../styles/stitches.config"

interface Props {
  label: string
  tooltip: string
}
export const LabelWithTooltip = ({ label, tooltip }: Props) => {
  return (
    <Flex css={{ display: "inline-flex" }} align="center">
      {label}

      <Spacer size={theme.space.s1} />

      <InfoBox inline variant="default" align="end">
        <InfoText type="textsLarge">{tooltip}</InfoText>
      </InfoBox>
    </Flex>
  )
}
